// extracted by mini-css-extract-plugin
export default {"transition-opacity":"Transition_transition-opacity__adMbr","opacity-0":"Transition_opacity-0__-TeD9","opacity-100":"Transition_opacity-100__tTs8S"};